import { logSentryError } from '@libs/common-next';
import { SnackbarUtils } from '@libs/shared-ui';

import { SentryErrors } from '@/shared/sentry';

type OnErrorProps = {
    event: 'add' | 'remove';
    error: Error;
};

export const useOnError = () => {
    return ({ event, error }: OnErrorProps) => {
        const sentryError =
            event === 'add'
                ? SentryErrors.FavoriteAPI.AddFavoriteFailed
                : SentryErrors.FavoriteAPI.RemoveFavoriteFailed;

        logSentryError(error, sentryError);

        SnackbarUtils.show({
            primaryText: 'Something went wrong. Please try again.',
            actionText: 'Refresh',
            onClick: () => window.location.reload(),
            preventDuplicate: true,
        });
    };
};
